import React from "react";
import {
  Center,
  Stack,
  Title,
  Text,
  Paper,
  ThemeIcon,
  Badge,
  Group,
} from "@mantine/core";
import { AppIcon } from "../AppIcon";
import { useApp } from "@/contexts/AppContext";

export const NoAccessMessage: React.FC = () => {
  const { userRolesNames } = useApp();

  return (
    <Center style={{ minHeight: "60vh" }}>
      <Paper
        shadow="sm"
        p="xl"
        radius="md"
        withBorder
        style={{ maxWidth: 500, width: "100%" }}
      >
        <Stack align="center" gap="lg">
          <ThemeIcon size={80} radius="xl" variant="light" color="red">
            <AppIcon iconName="Lock" size={40} />
          </ThemeIcon>

          <Stack align="center" gap="xs">
            <Title order={2} ta="center">
              Access Denied
            </Title>
            <Text size="md" c="dimmed" ta="center">
              You don't have permission to view this page
            </Text>
          </Stack>

          {userRolesNames && userRolesNames.length > 0 && (
            <Stack align="center" gap="xs">
              <Text size="sm" c="dimmed" ta="center">
                Your current role{userRolesNames.length > 1 ? "s" : ""}:
              </Text>
              <Group gap="xs" justify="center">
                {userRolesNames.map((role) => (
                  <Badge key={role} variant="light" color="gray" size="lg">
                    {role}
                  </Badge>
                ))}
              </Group>
              <Text size="sm" c="dimmed" ta="center" mt="xs">
                Users with{" "}
                {userRolesNames.length > 1 ? "these roles" : "this role"} do not
                have access to this page.
              </Text>
            </Stack>
          )}

          <Text size="sm" c="dimmed" ta="center" mt="md">
            If you believe you should have access to this content, please
            contact your account administrator for assistance with your access
            rights.
          </Text>
        </Stack>
      </Paper>
    </Center>
  );
};
